import React from "react";
import logo from "../assets/logo.png";
import { NavLink } from "react-router-dom";

export default function Navbar() {
  return (
    <>
      <section className="header_nav">
        <div className="newnav">
          <ul>
            <li>
              <NavLink to="/" end>
                A7SattaKing 🏡
              </NavLink>
            </li>
            <li>
              <NavLink to="/chart">Chart</NavLink>
            </li>
            <li>
              <NavLink to="/contact">Contact</NavLink>
            </li>
            {/* <li>
              <NavLink to="/login">Login</NavLink>
            </li> */}
          </ul>

          <div className="clearfix"></div>
        </div>
        <div className="ticker-wrapper">
          <div className="ticker">
            a7-sattakingg, a7-sattakingg live result, a7-sattakingg chart,
            a7-sattakingg online result, Gali result, Desawar result, Faridabad
            result, Gaziyabad result, Satta matka king, Gali live result,
            Disawar live result, Satta Number, Matka Number, Delhi
            a7-sattakingg, Satta Bazar
          </div>
        </div>

        {/* 🔥 Logo Section */}
        <div className="sattalogo">
          <div className="container text-center">
            <div className="logo">
              <img src={logo} alt="logo" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
